export class Command {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public enabled: boolean,
    public workspaceId: string | null,
    public userId: string | null,
    public createdAt: string,
  ) {}
}

export class CommandDetail {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public instruction: string,
    public enabled: boolean,
    public workspaceId: string | null,
    public userId: string | null,
    public createdAt: string,
    public updatedAt: string,
  ) {}
}
